import thinkingdata from 'thinkingdata-browser'
import { customSessionStorage } from '@/tool/storage'
import store from '@/store'

const config = {
  name: `ta_store_${process.env.VUE_APP_GAME_NAME}`,
  serverUrl: process.env.VUE_APP_TA_URL, //数据上传的URL
  autoTrack: {
    pageShow: true, //开启页面展示事件，事件名ta_page_show
    pageHide: true, //开启页面隐藏事件，事件名ta_page_hide
  },
  showLog: process.env.VUE_APP_ENV !== 'prod',
}

class Tracker {
  constructor() {
    this.instanceKey = `store_${process.env.VUE_APP_GAME_NAME}`
    this._ta = thinkingdata
  }
  install = (Vue, option) => {
    if (!option.appId) throw new Error('请设置appid')

    this.initParams(option)
    this.init(Vue)
    this.registerDirective(Vue)
  }

  initParams = (option) => {
    this.params = {
      ...config,
      ...option,
    }
  }

  init = (Vue) => {
    this._ta.init({
      ...this.params,
      autoTrack: {
        pageShow: false, //开启页面展示事件，事件名ta_page_show
        pageHide: false, //开启页面隐藏事件，事件名ta_page_hide
      },
    })
    this._ta.initInstance(this.instanceKey, this.params)
    this.ta = this._ta[this.instanceKey]

    const track = this.ta.track
    this.ta.track = (event, data) => {
      const gameId = store.state.app.gameId
      const gameConfig = store.state.config.gameConfig
      if (gameId === '20195') {
        if (event === 'vip_mall_view') {
          data = data || {}
          data.need_login_unlock = gameConfig.login_active === 1
        }
      }
      if (event === 'vip_mall_view') {
        const session = customSessionStorage.getItem('taview')
        if (session) return
        else customSessionStorage.setItem('taview', '1')
      }

      const newData = this.buildData(data)
      // console.group('===== ta.track =====')
      // console.log(event, newData)
      // console.groupEnd()
      track.apply(this.ta, [event, newData])
    }

    Vue.prototype.$ta = this.ta
    this.ta.setSuperProperties({
      createtime: Date.now(),
    })
  }

  /**
   * 使用示例：
   *  <img
   *   v-track:click|exposure
   *   track-event="offsite_enter"
   *   track-data-name="qzx"
   *   track-data-age="16"
   *   src="@/assets/images/googleBadge.png" alt=""
   *  >
   */
  registerDirective = (Vue) => {
    const _this = this
    Vue.directive('track', {
      bind(el, binding, vnode, oldVnode) {
        // 获取指令参数
        const { arg } = binding
        // 埋点名称
        const event = el.getAttribute('track-event').trim()
        // 埋点参数截取
        const data = {}
        for (let name of el.getAttributeNames()) {
          if (name.indexOf('track-data-') > -1) {
            data[name.substring(11)] = el.getAttribute(name)
          }
        }
        // 埋点上报方式处理，目前方式：点击、曝光（进入可视区域window）
        arg.split('|').forEach((item) => {
          if (item.trim() === 'click') {
            el.addEventListener('click', () => {
              _this.track(event, data)
            })
          } else if (item.trim() === 'exposure') {
            const io = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  if (entry.isIntersecting) {
                    io.unobserve(el)
                    _this.track(event, data)
                  }
                })
              },
              {
                root: null,
                rootMargin: '0px',
                threshold: [0],
              }
            )
            io.observe(el)
          }
        })
      },
    })
  }

  track = (event, data) => {
    this.ta.track(event, data)
  }

  buildData = (data) => {
    if (!data) return data
    // 去掉空字段
    Object.keys(data).forEach((key) => {
      if (data[key] === '' || data[key] === undefined) {
        delete data[key]
      }
    })
    return data
  }
}

export default new Tracker()
